import { Card, CardBody, Col } from "reactstrap";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";
import { H4, H6, P } from "../../../../../AbstractElements";
import ReactApexChart from "react-apexcharts";
import { TotalSalesChart } from "../../../../../Data/General/Widgets/General";
import { TotalSalesTitle } from "../../../../../Constants/Constants";

const TotalSales = () => {
  return (
    <Col xl="3" sm="6">
      <Card>
        <CardBody className="total-sale px-0">
          <div className="d-flex align-items-center gap-2">
            <div className="bg-icon bg-light-primary">
              <div className="flex-shrink-0 bg-light-primary">
                <SvgIcon iconId="fill-Buy" />
              </div>
            </div>
            <div className="flex-grow-1">
              <div className="d-flex align-items-center">
                <H4>{`$55.200`}</H4>
                <span className="text-truncate">{TotalSalesTitle}</span>
                <div className="total-icon mt-1">
                  <P className="mb-0 up-arrow bg-light-success me-1">
                    <i className="fa fa-arrow-up text-success" />
                  </P>
                  <span className="f-w-500 font-success me-1">{`+ 4.2% `}</span>
                  <H6>{`Than last week`}</H6>
                </div>
              </div>
            </div>
          </div>
          <div id="total-sales">
            <ReactApexChart type="area" options={TotalSalesChart} series={TotalSalesChart.series} height={105} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TotalSales;
